import { render, staticRenderFns } from "./SurveyIndividuals.vue?vue&type=template&id=46a94f0a"
import script from "./SurveyIndividuals.vue?vue&type=script&lang=js"
export * from "./SurveyIndividuals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports